import { render, staticRenderFns } from "./createExpenseView.vue?vue&type=template&id=176a4e3a&"
import script from "./createExpenseView.vue?vue&type=script&lang=js&"
export * from "./createExpenseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports